import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AgGridService } from '../ag-grid.service';
import { GridName } from '../../../model/ag-grid-common-constant';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cell-checkbox',
  templateUrl: './cell-checkbox.component.html',
  styleUrls: ['./cell-checkbox.component.scss']
})
export class CellCheckboxComponent implements OnInit, ICellRendererAngularComp {
  params: any;
  isChecked:boolean = false;
  isDisabled:boolean = false;
  isReadonly:boolean = false;
  gridName = GridName
  sub : Subscription
  subscription : Subscription

  constructor(public agGridService: AgGridService) {
  }
  ngOnInit(): void {
 this.sub =this.agGridService.toggleCheckboxIcon.subscribe((params) => {
      if (params?.value) {
        if(params?.params?.disable){
        this.isChecked = this.params.value = this.params?.data?.partContact
        }else{
       let value = params?.params
        this.params.value = value
        this.updatecheckedValue()
        this.onChange(value); }
      }
    })
  }
  agInit(params: any): void {
    this.params = params;
    this.updatecheckedValue()
    if (this.params?.context?.storageName === this.gridName.SEND_REQUEST)
      this.isDisabled = this.isReadonly = true
  }
  updatecheckedValue(){
    if (this.params.column.getColId() === 'partContact') {
    this.isChecked = this.params.value
    }
  }
  refresh(params: ICellRendererParams<any, any>): boolean {
    this.params = params;
    return true;
  }
  onChange(event){
    this.isChecked = this.params.value = event;
    const columnId = this.params.column.getId();
    this.params.data[columnId] = this.isChecked;
    this.params.api.refreshCells({ rowNodes: [this.params.node], force: true });
    this.agGridService.toggleHeaderCheckedValue.next({params:this.params,value:true})
  }
ngOnDestroy(): void {
  this.sub.unsubscribe();
}

}
